var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-main',[_c('simple-page',{attrs:{"name":"downloads"}},_vm._l((_vm.entries),function(data,key){return _c('download-entries',{key:key,attrs:{"category":key,"entries":data}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }